const firstNonEmpty = (values) => {
  for (const value of values) {
    if (typeof value === 'string' && value.trim() !== '') {
      return value.trim()
    }
  }
  return ''
}

/**
 * H112 — resuelve la identidad de ingeniería (Engineering item / Engineering revision) del conjunto
 * a partir de los componentes que la sección de BOM tiene cargados. La lista ya llega recortada a la
 * última importación por el backend (RN2, StandardWorkflowResourceService), así que aquí NO se
 * compara ninguna fecha: la única discriminación propia es descartar los componentes marcados como
 * eliminados por una reimportación (RN3). Devuelve `null` cuando no hay ningún dato de ingeniería, y
 * esa ausencia es la que hace que la ficha no se pinte (H112_S7/DEC-2). No se resuelve ningún
 * desempate entre valores distintos: DL2/DL3 quedan deliberadamente fuera de alcance.
 * @param {Array<{engItem?: string, engRevision?: string, deleted?: boolean}>} items
 * @returns {{engItem: string, engRevision: string} | null}
 */
export const resolveBomEngineeringIdentity = (items) => {
  const current = (items || []).filter((item) => item && !item.deleted)
  const engItem = firstNonEmpty(current.map((item) => item.engItem))
  const engRevision = firstNonEmpty(current.map((item) => item.engRevision))
  if (engItem === '' && engRevision === '') {
    return null
  }
  return { engItem, engRevision }
}
